import { useRouteError } from "react-router-dom"

import BreadCrumbs from "./components/BreadCrumbs"

export default function ErrorPage() {
    const crumbs = [
        {
            path: "/",
            name: "Home",
        },
    ]

    const error = useRouteError()
    console.error(error)

    return (
        <div>
            <BreadCrumbs crumbs={crumbs} />
            <div className="App-content text-center pt-2 align-items-center ">
                <div className="row pt-4">
                    <div className="col">
                        <h2 className="pt-2">Error</h2>
                        <p className="text-start lead small">
                            There was a problem loading the page you requested.
                            <br></br>
                            <br></br>
                            Click here to go back to the{" "}
                            <a href="/">home page</a>.<br></br>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}
